import script from "./UserLink.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserLink.vue?vue&type=script&setup=true&lang=ts"

import "./UserLink.vue?vue&type=style&index=0&id=4512f521&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4512f521"]])

export default __exports__